export default __webpack_public_path__ + "static/media/hourofpower.42e19df1.png";